var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAiSummaryThumbsdown = function SvgIcAiSummaryThumbsdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#16181C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.425 11.53h-.8a1 1 0 0 1-1-1V3.668a1 1 0 0 1 1-1h.8a1 1 0 0 1 1 1v6.864a1 1 0 0 1-1 1M4.822 9.98V4.667a2 2 0 0 1 2-2h4.581a1.67 1.67 0 0 1 1.608 1.228l1.306 4.792a1.667 1.667 0 0 1-1.608 2.104h-2.73v2.54a1.333 1.333 0 0 1-1.333 1.333h-.024a1.33 1.33 0 0 1-1.114-.6z"
  })));
};
export default SvgIcAiSummaryThumbsdown;